// NIS2 layout providing sub-navigation for all NIS2 compliance routes
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Menu } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { Nis2MobileNav } from '@/features/nis2/components/Nis2MobileNav';
import { Nis2Nav } from '@/features/nis2/components/Nis2Nav';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/nis2')({
  beforeLoad: ({ location }) => {
    // Redirect /nis2 to /nis2/dashboard
    if (location.pathname === '/nis2') {
      // TanStack Router expects redirect to be thrown as control flow
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/nis2/dashboard' });
    }
    return {
      getTitle: () => i18n.t('routeTitles.nis2Compliance'),
    };
  },
  component: Nis2Layout,
});

function Nis2Layout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="flex min-h-[calc(100vh-4rem)]">
      {/* Desktop sidebar navigation - hidden on mobile */}
      <Nis2Nav />

      {/* Mobile navigation sheet */}
      <Nis2MobileNav open={mobileNavOpen} onOpenChange={setMobileNavOpen} />

      {/* Main content area */}
      <div className="flex-1 overflow-auto">
        {/* Mobile hamburger button - shown only on mobile */}
        <div className="sticky top-0 z-10 flex items-center border-b bg-background px-4 py-2 md:hidden">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              setMobileNavOpen(true);
            }}
            aria-label="Open NIS2 navigation"
            className="h-11 w-11"
          >
            <Menu className="h-5 w-5" />
          </Button>
          <span className="ml-2 text-sm font-medium text-muted-foreground">NIS2 Compliance</span>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
